var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDC794"
    },
    d: "M459.09,220.69c0-19.421-15.89-35.31-35.31-35.31c-19.421,0-35.31,15.89-35.31,35.31v-44.138 c0-19.421-15.89-35.31-35.31-35.31c-19.421,0-35.31,15.89-35.31,35.31v-35.31c0-19.421-15.89-35.31-35.31-35.31l0,0 c-19.421,0-35.31,15.89-35.31,35.31v35.31V35.31c0-19.421-15.89-35.31-35.31-35.31l0,0c-19.421,0-35.31,15.89-35.31,35.31v229.517 l-15.89-23.834c-17.655-30.897-60.028-45.021-88.276-34.428c-4.414,0.883-7.062,3.531-10.593,5.297 c-10.593,7.062-8.828,15.007-8.828,17.655s50.317,53.848,79.448,105.931c0,0,25.6,42.372,52.966,70.621v26.483 c0,44.138,35.31,79.448,79.448,79.448h88.276c34.428,0,69.738-29.131,77.683-62.676c1.766-7.945,5.297-19.421,10.593-25.6 c7.945-8.828,17.655-30.897,17.655-61.793V220.69z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M185.434,291.31c-3.531,0-6.179-1.766-7.945-5.297l-8.828-17.655c-1.766-4.414,0-9.71,3.531-11.476 c4.414-1.766,9.71,0,11.476,3.531l8.828,17.655c1.766,4.414,0,9.71-3.531,11.476C188.083,291.31,187.2,291.31,185.434,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M247.228,291.31c-5.297,0-8.828-3.531-8.828-8.828V132.414c0-5.297,3.531-8.828,8.828-8.828 s8.828,3.531,8.828,8.828v150.069C256.055,287.779,252.524,291.31,247.228,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M317.848,282.483c-5.297,0-8.828-3.531-8.828-8.828v-97.103c0-5.297,3.531-8.828,8.828-8.828 c5.297,0,8.828,3.531,8.828,8.828v97.103C326.676,278.952,323.145,282.483,317.848,282.483"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M388.469,291.31c-5.297,0-8.828-3.531-8.828-8.828V220.69c0-5.297,3.531-8.828,8.828-8.828 s8.828,3.531,8.828,8.828v61.793C397.297,287.779,393.766,291.31,388.469,291.31"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M397.297,441.379c-3.531,0-7.945-2.648-8.828-6.179c-0.883-4.414,1.766-9.71,6.179-10.593 l5.297-0.883c19.421-5.297,30.014-7.945,33.545-19.421c1.766-4.414,6.179-7.062,11.476-5.297c4.414,1.766,7.062,6.179,5.297,11.476 c-7.062,21.186-26.483,25.6-45.903,30.897h-4.414C399.062,441.379,398.179,441.379,397.297,441.379"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9A671"
    },
    d: "M229.572,441.379c-1.766,0-3.531-0.883-5.297-1.766c-5.297-4.414-9.71-7.062-15.007-11.476 c-7.062-4.414-13.241-9.71-20.303-15.89c-3.531-3.531-3.531-8.828-0.883-12.359c3.531-3.531,8.828-3.531,12.359-0.883 c6.179,5.297,12.359,9.71,18.538,14.124c5.297,3.531,10.593,7.062,16.772,12.359c3.531,3.531,4.414,8.828,0.883,12.359 C234.869,440.497,232.221,441.379,229.572,441.379"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHand);
export default __webpack_public_path__ + "static/media/hand.c2ff0bf32706fad044b9bb92b261064e.svg";
export { ForwardRef as ReactComponent };